<div class="contact-container">
  <!-- <span class="contact" *ngFor="let contcat of params.value; let i=index" (click)="onSegmentClick(contcat)">
    {{contcat.first_name}} {{contcat.last_name}}{{i == params.value.length-1 ? '':', '}}
  </span> -->
  <span class="contact" *ngFor="let contcat of params.data.contacts; let i=index" (click)="onSegmentClick(contcat)">
    {{contcat.first_name}} {{contcat.last_name}}{{i == params.data.contacts.length-1 ? '':', '}}
  </span>
</div>